import { faToSvg } from './helpers.js'
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons'

let effectDelay = 500
let gallery = null
let slidesNode
let slides = []

/**
 * Init slideshow fullscreen
 */
function init( selector )
{
  slides = typeof selector == 'string' ? document.querySelectorAll( selector ) : selector

  slides.forEach( ( slide, index ) => {

    slide.setAttribute( 'index', index )

    slide.addEventListener( 'click', function(e){
      return openGallery( this )
    })
  })
}

function openGallery( startSlide )
{
  if( !gallery ){
    gallery = initializeDom()
  }

  document.body.classList.add( 'slideshow-on' )

  goSlide( startSlide.getAttribute( 'index' ) )
}

function initializeDom()
{
  const gallery = document.createElement( 'div' )
  gallery.className = 'slideshow-gallery'

  slidesNode = document.createElement( 'div'  )
  slidesNode.className = 'slideshow-slides'

  slides.forEach( (slide, index) => {
    const slideNode = document.createElement( 'div' )
    slideNode.className = 'slideshow-slide'
    slideNode.setAttribute( 'index', index )
    slideNode.setAttribute( 'data-src', slide.getAttribute( 'data-big') )
    slidesNode.appendChild( slideNode )
  })

  gallery.appendChild( slidesNode )

  const navigation = document.createElement( 'div' )
  navigation.className = 'slideshow-navigation'

  const next = document.createElement( 'a' )
  next.className = 'slideshow-btn slideshow-next-btn'
  next.href = '#'
  next.title = 'Avanti'
  next.addEventListener( 'click', nextSlide )
  next.appendChild( faToSvg( faChevronRight.icon ) )
  navigation.appendChild( next )

  const prev = document.createElement( 'a' )
  prev.className = 'slideshow-btn slideshow-prev-btn'
  prev.href = '#'
  prev.title = 'Indietro'
  prev.addEventListener( 'click', prevSlide )
  prev.appendChild( faToSvg( faChevronLeft.icon ) )
  navigation.appendChild( prev )

  const exit = document.createElement( 'a' )
  exit.className = 'slideshow-btn slideshow-exit-btn'
  exit.href = '#'
  exit.title = 'Chiudi'
  exit.addEventListener( 'click', close )
  exit.appendChild( faToSvg( faTimes.icon ) )
  navigation.appendChild( exit )

  gallery.appendChild( navigation )

  document.body.appendChild( gallery )

  return gallery
}

function goSlide( index )
{
  const slide = slidesNode.children[ index ]

  //remove active
  const active = slidesNode.querySelector( '.active' )

  if( active ){
    const classes = active.classList
    classes.remove( 'active' )

    setTimeout( () => {
      classes.remove( 'slide-go-next' )
      classes.remove( 'slide-go-prev' )
    }, effectDelay )
  }

  slide.style.backgroundImage = `url('${slide.getAttribute( 'data-src' )}')`
  slide.classList.add( 'active' )
}

function nextSlide( e, )
{
  e.preventDefault()

  const active = slidesNode.querySelector( '.active' )
  if( !active ) return

  const index = parseInt( active.getAttribute( 'index' ) )

  active.classList.add( 'slide-go-next' )

  goSlide( index < slidesNode.children.length-1 ? index + 1 : 0 )
}

function prevSlide( e )
{
  e.preventDefault()

  const active = slidesNode.querySelector( '.active' )
  if( !active ) return

  const index = parseInt( active.getAttribute( 'index' ) )

  active.classList.add( 'slide-go-prev' )

  goSlide( index > 0 ? index-1 : slidesNode.children.length-1 )
}

function close( e )
{
  e.preventDefault()

  document.body.classList.remove( 'slideshow-on' )
}

export default {
  init,
}
